import { Card, Row, Col, Placeholder } from "react-bootstrap"


export const ClientIntakeLoadingComponent = () => {

    return (
        <>
            <SingleClient />
            <SingleClient />
        </>
    )
}

export const SingleClient = () => {
    return (
        <Card>
            <Card.Header>
                <Placeholder as={Card.Title} animation="glow" className="col-12">
                    <Placeholder xs={4} size="lg" bg="secondary" />
                </Placeholder>
            </Card.Header>

            <Card.Body>
                <Row className="mb-5">
                    <Placeholder as={Col} animation="glow" className="col-4">
                        <Placeholder xs={4} size="lg" bg="secondary" />
                        <br />
                        <Placeholder xs={8} size="lg" bg="secondary" />
                    </Placeholder>
                    <Placeholder as={Col} animation="glow" className="col-4">
                        <Placeholder xs={10} size="lg" bg="secondary" />
                        <br />
                        <Placeholder xs={5} size="lg" bg="secondary" />
                    </Placeholder>
                    <Placeholder as={Col} animation="glow" className="col-4">
                        <Placeholder xs={9} size="lg" bg="secondary" />
                        <br />
                        <Placeholder xs={6} size="lg" bg="secondary" />
                    </Placeholder>
                </Row>
           
                <Row>
                    <Placeholder as={Col} animation="glow" className="col-4">
                        <Placeholder xs={8} size="lg" bg="secondary" />
                        <br />
                        <Placeholder xs={10} size="lg" bg="secondary" />
                    </Placeholder>
        
                    <Placeholder as={Col}  animation="glow" className="col-4">
                        <Placeholder xs={7} size="lg" bg="secondary" />
                        <br />
                        <Placeholder xs={5} size="lg" bg="secondary" />
                    </Placeholder>
                </Row>
            </Card.Body>
        </Card>
    )
}